
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/finn",
      function () {
        return require("private-next-pages/finn/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/finn"])
      });
    }
  